import { forwardRef } from 'react';
import { Icon } from '@chakra-ui/react';
import { QIconProps } from './Icon';

export const Tools = forwardRef<SVGSVGElement, Partial<QIconProps>>(
  (props, ref) => {
    return (
      <Icon viewBox="0 0 24 24" color="currentColor" {...props} ref={ref}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
        >
          <g clipPath="url(#clip0_844_18711)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.191 8.704c-.1 0-.213 0-.313-.022a1.946 1.946 0 01-1.434-1.065L.15 3.034A1.398 1.398 0 01.406 1.42L1.414.412A1.378 1.378 0 013.027.154l4.58 2.297a1.96 1.96 0 01.616 3.015l2.866 2.869 2.33-2.331-.191-.942a3.076 3.076 0 01.84-2.779l.739-.74A4.166 4.166 0 0119.096.525l1.086.359c.28.09.481.325.549.605a.845.845 0 01-.225.784l-2.172 2.174.213.639.638.213 2.173-2.174a.843.843 0 01.783-.224c.28.067.516.28.605.549l.358 1.087a4.179 4.179 0 01-1.019 4.292l-.739.74a3.062 3.062 0 01-2.777.84l-.94-.19-1.13 1.13 6.594 6.6c.582.583.907 1.356.907 2.174 0 .818-.325 1.603-.907 2.174l-.795.796a3.05 3.05 0 01-2.172.896l-.011.011a3.077 3.077 0 01-2.173-.896l-6.595-6.6-1.109 1.11.19.941a3.076 3.076 0 01-.84 2.78l-.738.739a4.198 4.198 0 01-4.289 1.02l-1.086-.359a.832.832 0 01-.549-.605.845.845 0 01.224-.785l2.172-2.173-.212-.64-.639-.212L2.3 20.493a.843.843 0 01-.784.224.854.854 0 01-.605-.55l-.358-1.086a4.179 4.179 0 011.02-4.292l.738-.74a3.07 3.07 0 012.777-.84l.94.19 2.296-2.296L5.46 8.235a1.97 1.97 0 01-1.29.48l.022-.012zm8.343 6.611l6.584 6.589c.549.549 1.433.549 1.982 0l.795-.796a1.384 1.384 0 000-1.972l-6.584-6.59-2.766 2.769h-.01zM6.946 4.39l-.48.48-.013.013-1.58 1.58-.012.013-.468.469c-.09.078-.19.078-.247.078a.3.3 0 01-.201-.157L1.739 2.462h.011l.728-.728 4.4 2.207c.101.056.146.146.146.202a.268.268 0 01-.078.247zm2.53 5.49L6.654 7.058l.392-.392 2.822 2.823-.392.393zM5.31 21.549a2.503 2.503 0 002.354-.674l.739-.74c.324-.325.47-.806.38-1.255l-.268-1.378a.838.838 0 01.235-.762l8.029-8.035a.867.867 0 01.761-.235l1.377.269c.46.09.93-.056 1.266-.381l.739-.74a2.507 2.507 0 00.672-2.364l-1.568 1.569a.845.845 0 01-.862.201l-1.534-.504a.83.83 0 01-.538-.538l-.504-1.535a.851.851 0 01.202-.863l1.567-1.569a2.503 2.503 0 00-2.362.673l-.74.74c-.335.335-.47.806-.38 1.266l.269 1.378a.838.838 0 01-.235.762l-8.03 8.034a.867.867 0 01-.76.236l-1.378-.27c-.459-.089-.93.057-1.265.382l-.74.74a2.507 2.507 0 00-.671 2.364l1.568-1.569a.845.845 0 01.862-.202l1.534.505a.83.83 0 01.537.538l.504 1.535c.101.302.023.627-.201.863l-1.559 1.56z"
              fill="currentColor"
              color="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_844_18711">
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </svg>
      </Icon>
    );
  },
);

Tools.displayName = 'Tools';
